<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  created() {
    console.log("%c" + process.env.VUE_APP_VERSION, "color:blue;font-size: 14px;font-weight: 700")
  },
};
</script>